import { PassengerFragment } from '@websky/graphql';

import { ExchangePassengersState } from '../model/types';

export function getInitialPassengerState(
	passengers: PassengerFragment[],
	initialValue: boolean = false
): ExchangePassengersState {
	const initialState: ExchangePassengersState = {};

	passengers.forEach(passenger => {
		initialState[passenger.id] = initialValue;
	});

	return initialState;
}
